import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DashboardContext from 'Context';
import InputControlMulti from 'components/inputs/InputControlMulti';
import { getdata } from '../Data';

/**
 * این کامپوننت برای اکردیون های فرم است که یک داده را میخواند
 */
const FormAccordion = ({
  urldata,
  handelAccordion,
  formvalueAccordion,
  defaultValue,
}) => {
  const {
    authentication,
    urldashboard,
    handelAdd,
    handelloding,
    handeldmicro,
  } = useContext(DashboardContext);

  const [dataFech, setDataFech] = useState({});

  const handelData = (data) => setDataFech(data);

  const dataFeching = async () => {
    await getdata(
      `${urldashboard}/${urldata}`,
      authentication,
      handelData,
      handelloding,
      handelAdd,
      handeldmicro
    );
  };

  useEffect(() => {
    dataFeching();
    return () => {};
  }, []);

  const handelValue = (name, value) => {
    dataFech.map((item) =>
      item.specificationValues.map((nameControl) => {
        switch (name) {
          case nameControl.dropDownName:
            handelAccordion([...formvalueAccordion, value]);
            break;
          default:
            break;
        }
      })
    );
  };

  return (
    <Accordion>
      {dataFech.length > 1
        ? dataFech.map((item, index) => (
            <Card key={index}>
              <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                {item.title}
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={index + 1}>
                <Card.Body
                // style={{ minHeight: "680px" }}
                >
                  <Row>
                    {item.specificationValues.map((items, index) => (
                      <Col lg={6} md={6} sm={6} xs={12} key={index}>
                        <InputControlMulti
                          disabled
                          defaultValue={defaultValue}
                          label={items.dropDownName}
                          name={items.dropDownName}
                          handelValue={handelValue}
                          data={items.dropDownValues}
                        />
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          ))
        : null}
    </Accordion>
  );
};

export default FormAccordion;

FormAccordion.propTypes = {
  /**این مقدار ادرس برای دریافت اکاردیون است */
  urldata: PropTypes.string,
  /**ارسال داده کامپوننت به بالا است */
  handelAccordion: PropTypes.func,
  /**ارایه داده فرم اس که برای کامل کردن است */
  formvalueAccordion: PropTypes.array,
  /**مقدار پیش فرض برای اینپوت ها است */
  defaultValue: PropTypes.string,
};
